import { Grid, Stack } from '@mui/material';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { Fragment } from 'react';
import { z } from 'zod';

import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { AdministrationBody } from '@/components/management/layout/AdministrationBody';
import { AdministrationHeader } from '@/components/management/layout/AdministrationHeader';
import { Login } from '@/components/public/Login';

const defaultSearchValues = {
  redirect: undefined,
};

const zValidateSearch = z.object({
  redirect: z.string().optional().catch(defaultSearchValues.redirect),
});

export const Route = createFileRoute('/_public/_authentication/login')({
  validateSearch: zValidateSearch,
  search: {
    middlewares: [stripSearchParams(defaultSearchValues)],
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Fragment>
      <Header />
      <AdministrationHeader label="Login" />
      <AdministrationBody>
        <Grid
          container
          direction={{ sm: 'column', lg: 'row' }}
          spacing={{ sm: 2, lg: 13 }}
          sx={{ pt: { xs: 8, lg: 0 } }}
        >
          <Grid size={{ sm: 12, lg: 5.5 }} sx={{ mx: 'auto' }}>
            <Login />
          </Grid>
        </Grid>
      </AdministrationBody>
      <Stack
        component="footer"
        sx={{
          display: { xs: 'none', lg: 'flex' },
          position: 'fixed',
          bottom: 0,
          width: '100%',
        }}
      >
        <Footer />
      </Stack>
    </Fragment>
  );
}
